import { render, staticRenderFns } from "./PriceIQSettings.vue?vue&type=template&id=120c6944"
import script from "./PriceIQSettings.vue?vue&type=script&lang=js"
export * from "./PriceIQSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports